import { render } from "./AllLabs.vue?vue&type=template&id=57d8693c"
import script from "./AllLabs.vue?vue&type=script&lang=js"
export * from "./AllLabs.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/topdog/labs/AllLabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57d8693c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57d8693c', __exports__)) {
    console.log('reload')
    api.reload('57d8693c', __exports__)
  }
  
  module.hot.accept("./AllLabs.vue?vue&type=template&id=57d8693c", () => {
    console.log('re-render')
    api.rerender('57d8693c', render)
  })

}


export default __exports__